/**
 * Audio manifest — GENERATED by scripts/extract-assets.mjs. Do not edit by hand.
 *
 * The original build inlined every clip as base64. Audio now loads over the network
 * from the files that script writes, so this list is the single place that knows
 * which clips exist and what container each one uses.
 *
 * Music is an optional local asset and is not distributed with the source; a missing
 * track degrades to silence. See docs/assets.md.
 */

// Vite rewrites BASE_URL at build time, so the same source works when the game is
// served from "/" in development and from "/robot-warrior/" on GitHub Pages.
const BASE = import.meta.env?.BASE_URL ?? '/';

/** @typedef {{ key: string, ext: 'mp3' | 'ogg' }} Clip */

/** Mission soundtrack cue keys, in load order. @type {Clip[]} */
export const MUSIC_CLIPS = [
  {
    key: 'boot',
    ext: 'mp3',
  },
  {
    key: 'basin',
    ext: 'mp3',
  },
  {
    key: 'works',
    ext: 'mp3',
  },
];

/** Radio and cockpit voice lines. @type {Clip[]} */
export const VOICE_CLIPS = [
  {
    key: 'reactor',
    ext: 'ogg',
  },
  {
    key: 'motion',
    ext: 'ogg',
  },
  {
    key: 'weapons',
    ext: 'ogg',
  },
  {
    key: 'ready',
    ext: 'ogg',
  },
  {
    key: 'insertion',
    ext: 'ogg',
  },
  {
    key: 'contact',
    ext: 'ogg',
  },
  {
    key: 'target',
    ext: 'ogg',
  },
  {
    key: 'lock',
    ext: 'ogg',
  },
  {
    key: 'destroy',
    ext: 'ogg',
  },
  {
    key: 'relay',
    ext: 'ogg',
  },
  {
    key: 'uplink',
    ext: 'ogg',
  },
  {
    key: 'heat',
    ext: 'ogg',
  },
  {
    key: 'shutdown',
    ext: 'ogg',
  },
  {
    key: 'online',
    ext: 'ogg',
  },
  {
    key: 'armor',
    ext: 'ogg',
  },
  {
    key: 'limb',
    ext: 'ogg',
  },
  {
    key: 'coolant',
    ext: 'ogg',
  },
  {
    key: 'ammo',
    ext: 'ogg',
  },
  {
    key: 'victory',
    ext: 'ogg',
  },
  {
    key: 'death',
    ext: 'ogg',
  },
  {
    key: 'extract',
    ext: 'ogg',
  },
  {
    key: 'disabled',
    ext: 'ogg',
  },
  {
    key: 'nolock',
    ext: 'ogg',
  },
  {
    key: 'nav',
    ext: 'ogg',
  },
  {
    key: 'basinSecure',
    ext: 'ogg',
  },
  {
    key: 'works',
    ext: 'ogg',
  },
  {
    key: 'shield',
    ext: 'ogg',
  },
  {
    key: 'feed',
    ext: 'ogg',
  },
  {
    key: 'exposed',
    ext: 'ogg',
  },
  {
    key: 'coreDown',
    ext: 'ogg',
  },
  {
    key: 'repair',
    ext: 'ogg',
  },
  {
    key: 'enhanced',
    ext: 'ogg',
  },
  {
    key: 'optical',
    ext: 'ogg',
  },
  {
    key: 'ridgeRoute',
    ext: 'mp3',
  },
  {
    key: 'ridgeEntry',
    ext: 'mp3',
  },
  {
    key: 'batteryDown',
    ext: 'mp3',
  },
  {
    key: 'linkAttack',
    ext: 'mp3',
  },
  {
    key: 'commander',
    ext: 'mp3',
  },
  {
    key: 'linkJammed',
    ext: 'mp3',
  },
  {
    key: 'flightClear',
    ext: 'mp3',
  },
];

const MUSIC_EXT = Object.fromEntries(MUSIC_CLIPS.map((c) => [c.key, c.ext]));

/**
 * Clips inlined as data URLs by the offline single-file build.
 *
 * fetch() accepts a data URL, so the loaders need no special case: the offline
 * bundle installs this map and every clip resolves without a network request.
 * Undefined in a normal build.
 *
 * @type {Record<string, string> | undefined}
 */
const INLINE = /** @type {any} */ (globalThis).__ROBOTWARRIOR_ASSETS__;

/** @param {string} assetPath */
function resolve(assetPath) {
  return INLINE?.[assetPath] ?? BASE + assetPath;
}

/**
 * URL for a soundtrack cue.
 * @param {string} key
 */
export function musicUrl(key) {
  return resolve(`audio/music/${key}.${MUSIC_EXT[key] ?? 'mp3'}`);
}

/**
 * URL for a voice clip.
 * @param {Clip} clip
 */
export function voiceUrl(clip) {
  return resolve(`audio/voice/${clip.key}.${clip.ext}`);
}
